<ng-container *ngIf="cargando">
  <div fxLayout="column" class="p-20" fxLayoutAlign="space-between center" >
    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
    <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
  </div>
</ng-container>

<ng-container *ngIf="!cargando">
  <form [formGroup]="formGroupForAll">
  <mat-table [dataSource]="dataSource" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">

    <!-- Name Column -->

    <ng-container matColumnDef="practice" >

      <mat-header-cell *matHeaderCellDef class="pracDes">
        <p> {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.PRACT' | translate}}</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let element;let idxPract = index;" fxLayout="column" fxLayoutAlign="stretch">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>{{'CERTIFICAR.FORALL.TABLA.INPUTS.PRACT' | translate}}</mat-label>
            <textarea matInput required
              [disabled]="pasoCompleto"
              (keyup)="updateText($event,'txtPrac'+element.position,element.position)"
              (blur)="onBlurPractica($event,'txtPrac'+element.position,element.position);"
              [(ngModel)]="element.practice"
              formControlName="practica{{idxPract}}"
            >
            </textarea>
          <mat-error>{{'CERTIFICAR.FORALL.MSJ_PRACTICEREQUIRED' | translate}}</mat-error>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef class="pracDes">
      <p>   {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.DESCR' | translate}}</p>
    </mat-header-cell>
      <mat-cell *matCellDef="let element;let idxDescr = index;">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>{{'CERTIFICAR.FORALL.TABLA.INPUTS.DESCR' | translate}}</mat-label>
            <textarea matInput required
              [disabled]="pasoCompleto"
              (blur)="onBlurDescripcion($event,'txtDesc'+element.position,element.position);"
              [(ngModel)]="element.description"
              formControlName="descrip{{idxDescr}}"
            ></textarea>
            <mat-error>{{'CERTIFICAR.FORALL.MSJ_DESCRIPTIONREQUIRED' | translate}}</mat-error>
        </mat-form-field>
    </mat-cell>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="statement1">
        <mat-header-cell *matHeaderCellDef class="statems">
      <p>  {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.STT1' | translate}}</p>
    </mat-header-cell>
      <mat-cell *matCellDef="let element" style="text-align: center;">
        <p style="padding: 10px;" >{{element.statement1Part1}} <code>{{ element.practice }}</code> {{ element.statement1Part2 }} </p>
      </mat-cell>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="statement2">
    <mat-header-cell *matHeaderCellDef class="statems">
      <p>  {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.STT2' | translate}}</p>
    </mat-header-cell>
      <mat-cell *matCellDef="let element" style="text-align: center;">
       <p style="padding: 10px;" >{{element.statement2Part1}} <code>{{ element.practice }}</code> {{ element.statement2Part2 }} <code>{{ nombreEmpresa }}</code>?</p>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
  </form>
</ng-container>
